import * as yup from "yup";
import {
  approvalManagementTypes,
  approvalRequiredTypes,
} from "../../../../enums";
import { IManageUserTransferLimit } from "../../../../interfaces-and-types";

export const manageUserTransferLimitSchema: yup.SchemaOf<IManageUserTransferLimit> =
  yup.object({
    staff_id: yup.string().required("Staff ID is required"),
    currency: yup.string().required("Currency is required"),
    description: yup.string().nullable().optional(),

    // By approval requirement
    approval_required_type: yup
      .mixed<approvalRequiredTypes>()
      .required("Approval required type is required"),
    approval_count_required: yup
      .number()
      .nullable()
      // when approval_required_type !== approvalRequiredTypes.NONE then a min of 1 is required
      .when("approval_required_type", {
        is: (approval_required_type: approvalRequiredTypes) =>
          approval_required_type !== approvalRequiredTypes.none,
        then: yup.number().min(1, "Approval count required must be at least 1"),
        otherwise: yup
          .number()
          .min(0, "Approval count required must be at least 0"),
      })
      .transform((_value, originalValue) =>
        !originalValue ? 0 : Number(originalValue.toString().replace(/,/g, ""))
      )
      .required("Approval count required is required"),
    approval_management_type: yup
      .mixed<approvalManagementTypes>()
      .required("Approval management type is required"),
    approver_staff_list: yup
      .array()
      .of(yup.string().required())
      .required("Approver staff list is required"),
    approver_roles_list: yup
      .array()
      .of(yup.string().required())
      .required("Approver roles list is required"),
    // approver_staff_list: yup.array().of(
    //   yup
    //     .object()
    //     .shape({
    //       staff_id: yup.string().required(),
    //     })
    //     //   .required("Please enter a valid staff ID")
    //     .nullable()
    //     .optional()
    // ),
    // approver_roles_list: yup.array().of(
    //   yup
    //     .object()
    //     .shape({
    //       role: yup.string().email("Please enter a valid role").required(),
    //     })
    //     //   .required("Please enter a valid Role")
    //     .nullable()
    //     .optional()
    // ),
    // helpers
    approver_staff_list_helper: yup
      .array()
      .of(
        yup.object().shape({
          id: yup.string().required(),
          value: yup.string().required(),
        })
      )
      .optional(),
    approver_roles_list_helper: yup
      .array()
      .of(
        yup.object().shape({
          id: yup.string().required(),
          value: yup.string().required(),
        })
      )
      .optional(),

    // By volume
    single_transfer_amount_limit: yup
      .number()
      .nullable()
      .min(0, "Transaction amount limit cannot be negative")
      .transform((_value, originalValue) =>
        !originalValue
          ? null
          : Number(originalValue.toString().replace(/,/g, ""))
      )
      .optional(),
    daily_amount_limit: yup
      .number()
      .nullable()
      .min(0, "Daily amount limit cannot be negative")
      .transform((_value, originalValue) =>
        !originalValue
          ? null
          : Number(originalValue.toString().replace(/,/g, ""))
      )
      .optional(),
    monthly_amount_limit: yup
      .number()
      .nullable()
      .min(0, "Monthly amount limit cannot be negative")
      .transform((_value, originalValue) =>
        !originalValue
          ? null
          : Number(originalValue.toString().replace(/,/g, ""))
      )
      .optional(),
    yearly_amount_limit: yup
      .number()
      .nullable()
      .min(0, "Yearly amount limit cannot be negative")
      .transform((_value, originalValue) =>
        !originalValue
          ? null
          : Number(originalValue.toString().replace(/,/g, ""))
      )
      .optional(),
    // By count
    daily_count_limit: yup
      .number()
      .nullable()
      .min(0, "Daily count limit cannot be negative")
      .transform((_value, originalValue) =>
        !originalValue
          ? null
          : Number(originalValue.toString().replace(/,/g, ""))
      )
      .optional(),
    monthly_count_limit: yup
      .number()
      .nullable()
      .min(0, "Monthly count limit cannot be negative")
      .transform((_value, originalValue) =>
        !originalValue
          ? null
          : Number(originalValue.toString().replace(/,/g, ""))
      )
      .optional(),
    yearly_count_limit: yup
      .number()
      .nullable()
      .min(0, "Yearly count limit cannot be negative")
      .transform((_value, originalValue) =>
        !originalValue
          ? null
          : Number(originalValue.toString().replace(/,/g, ""))
      )
      .optional(),

    // // By volume
    // single_transfer_amount_limit: yup
    //   .number()
    //   .nullable()
    //   .min(0, "Transaction amount limit cannot be negative")
    //   .optional(),
    // daily_amount_limit: yup
    //   .number()
    //   .nullable()
    //   .min(0, "Daily amount limit cannot be negative")
    //   .optional(),
    // monthly_amount_limit: yup
    //   .number()
    //   .nullable()
    //   .min(0, "Monthly amount limit cannot be negative")
    //   .optional(),
    // yearly_amount_limit: yup
    //   .number()
    //   .nullable()
    //   .min(0, "Yearly amount limit cannot be negative")
    //   .optional(),

    // // By count
    // daily_count_limit: yup
    //   .number()
    //   .nullable()
    //   .min(0, "Daily count limit cannot be negative")
    //   .optional(),
    // monthly_count_limit: yup
    //   .number()
    //   .nullable()
    //   .min(0, "Monthly count limit cannot be negative")
    //   .optional(),
    // yearly_count_limit: yup
    //   .number()
    //   .nullable()
    //   .min(0, "Yearly count limit cannot be negative")
    //   .optional(),

    // limit_deltas: yup.array().of(yup.object().shape({
    //     // Define the structure of ManageUserTransferLimitDeltaDto here if needed
    // })).required('Limit deltas are required'),
  });
